<template>
    <div class="submit-assignment">
        <b-button
            class="btn-upload btn-hand-in-sub-assignment"
            variant="primary"
            @click="submit()"
            data-toggle="tooltip"
            data-placement="bottom"
            :data-original-title="$t('assignment.submit_sub_assignment_title')">
            {{
                typeIn === 'only_explanation'
                    ? $t('assignment.viewed_sub_assignment')
                    : $t('assignment.submit_sub_assignment')
            }}
        </b-button>
        <design-2021-assignment-skill-tree-skill-picker-component
            ref="rubric-skill-picker"
            @chosen-skill-ids="submitForAssignmentSkillTree"></design-2021-assignment-skill-tree-skill-picker-component>
    </div>
</template>

<script>
import { ords } from '../../../../app';

const subAssignmentStatusOrds = ords.use('subAssignmentStatus');
const assignmentStatusOrds = ords.use('assignmentStatus');
const assignmentOrds = ords.use('assignment');

export default {
    name: 'design-2021-assignment-show-sub-assignment-submit-component',
    props: ['assignmentIn', 'subAssignmentIn', 'projectId', 'assignmentStatusIn', 'typeIn'],
    data() {
        return {
            arUser: null,
        };
    },
    computed: {
        unAnsweredParts() {
            let partsUnanswered = false;
            this.subAssignmentIn.pages.forEach((page) => {
                page.parts.forEach((part) => {
                    if (!part.answers.length && part.type === 2) {
                        partsUnanswered = true;
                    }
                });
            });

            return partsUnanswered;
        },
    },
    methods: {
        rubricCanSubmit() {
            if (this.$authUser.isStudent() && this.assignmentIn.assignment_rubrics.length) {
                let arUser = null;
                this.assignmentIn.assignment_rubrics.forEach((assignmentRubric) => {
                    arUser = assignmentRubric.assignment_rubric_users.find(
                        (arUser) => arUser.user_id === this.$authUser.id,
                    );
                });
                if (arUser) {
                    this.arUser = arUser;
                    for (const rubricForm of arUser.rubric_forms) {
                        if (!rubricForm.rubric_form_results.length) {
                            return false;
                        }
                        let myResults = rubricForm.rubric_form_results.find(
                            (result) => result.user_id === this.$authUser.id,
                        );
                        if (myResults === undefined) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            } else if (this.$authUser.isStudent() && this.assignmentIn.assignment_skill_tree) {
                return false;
            }
            return true;
        },
        submit() {
            let assignment = [];
            assignmentOrds
                .with('sub_assignments')
                .find(this.subAssignmentIn.assignment_id)
                .subscribe((sub) => {
                    assignment = sub;
                });

            let submitText = this.$t('assignment.confirm_submit_sub_assignment');
            let watchText = this.$t('assignment.submit_sub_assignment');

            if (this.unAnsweredParts) {
                submitText = this.$t('assignment.submit_sub_assignment_confirm_parts_not_answered');
                watchText = this.$t('assignment.submit_anyway');
            }

            let text = submitText + ' ' + this.$t('assignment.all_other_sub_assignments_submitted');

            if (this.subAssignmentIn.onlyExplanation()) {
                watchText = this.$t('assignment.viewed');
                text = this.$t('assignment.confirm_viewed_all_others_viewed');
            }

            let statuses = [];

            if (assignment.sub_assignments.length !== 0) {
                assignment.sub_assignments.forEach((sub) => {
                    if (sub.id !== this.subAssignmentIn.id) {
                        if (sub.statuses.length !== 0) {
                            sub.statuses.forEach((status) => {
                                if (status.finished === 1) {
                                    statuses.push(true);
                                } else {
                                    statuses.push(false);
                                }
                            });
                        } else {
                            statuses.push(false);
                        }
                    }
                });
            }

            if (statuses.includes(false)) {
                if (this.subAssignmentIn.onlyExplanation()) {
                    text = this.$t('assignment.confirm_viewed');
                } else {
                    text = submitText;
                }
            }
            if (
                this.assignmentIn.assignment_skill_tree &&
                !statuses.includes(false) &&
                !this.rubricCanSubmit() &&
                !this.arUser
            ) {
                this.$refs['rubric-skill-picker'].show(this.assignmentIn);
                return;
            } else if (this.assignmentIn.assignment_rubrics && !statuses.includes(false) && !this.rubricCanSubmit()) {
                watchText = watchText + ' na Rubric(s)';
                text = submitText + ' ' + this.$t('assignment.text_rubrics_first_then_submit_assignment');
            }
            this.alert.confirm(`Deelopdracht ${watchText}`, text, watchText).then((confirm) => {
                if (confirm) {
                    this.alert.saving();
                    const data = {
                        sub_assignment_id: this.subAssignmentIn.id,
                        project_id: this.projectId,
                    };
                    this.axios.post(this.routes.subAssignmentStatusSubmit(), data).then(
                        (response) => {
                            // redirect to rubric.
                            if (response.data.redirect) {
                                window.location.href = this.routes.assignmentRubricEdit(response.data.arUserId);
                                return;
                            }
                            // sub assignment
                            ords.hold();
                            if (this.subAssignmentIn.hasStatus()) {
                                this.subAssignmentIn.getStatus().update(response.data.status);
                                for (let activity of response.data.status.activities) {
                                    this.subAssignmentIn.getStatus().addRelation('activities', activity);
                                }
                            } else {
                                this.subAssignmentIn.addRelation('statuses', response.data.status);
                            }

                            if (!response.data.assignment_status) {
                                ords.continue();
                                this.alert.success();
                                return;
                            }

                            if (this.assignmentStatusIn) {
                                this.assignmentStatusIn.update(response.data.assignment_status);

                                for (let activity of response.data.assignment_status.activities) {
                                    this.assignmentStatusIn.addRelation('activities', activity);
                                }
                            } else {
                                assignmentStatusOrds.add(response.data.assignment_status);
                                assignmentOrds.attach(
                                    this.subAssignmentIn.assignment_id,
                                    'statuses',
                                    response.data.assignment_status.id,
                                );
                            }

                            ords.continue();

                            this.$emit('submitted');
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                }
            });
        },
        submitForAssignmentSkillTree(skillIds) {
            const data = {
                sub_assignment_id: this.subAssignmentIn.id,
                project_id: this.projectId,
                skill_ids: skillIds,
            };

            this.axios.post(this.routes.subAssignmentStatusSubmit(), data).then(
                (response) => {
                    // redirect to rubric.
                    if (response.data.redirect) {
                        window.location.href = this.routes.assignmentRubricEdit(response.data.arUserId);
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.submit-assignment {
    margin-left: auto;
}
</style>
